import { buildModelManager } from "../builder.js";
const DefaultCreditNoteSelection = {
  __typename: true,
  id: true,
  amount: true,
  createdAt: true,
  creditNoteNumber: true,
  deletedAt: true,
  issuedAt: true,
  notes: true,
  originalInvoiceId: true,
  profileId: true,
  reason: true,
  reasonCategory: true,
  sentToClientAt: true,
  sentToClientById: true,
  status: true,
  updatedAt: true,
  voidReason: true,
  voidedAt: true
};
const modelApiIdentifier = "creditNote";
const pluralModelApiIdentifier = "creditNotes";
;
;
;
;
;
;
;
;
;
;
;
;
const operations = [
  {
    type: "findOne",
    operationName: modelApiIdentifier,
    modelApiIdentifier,
    findByVariableName: "id",
    defaultSelection: DefaultCreditNoteSelection,
    namespace: null
  },
  {
    type: "maybeFindOne",
    operationName: modelApiIdentifier,
    modelApiIdentifier,
    findByVariableName: "id",
    defaultSelection: DefaultCreditNoteSelection,
    namespace: null
  },
  {
    type: "findMany",
    operationName: pluralModelApiIdentifier,
    modelApiIdentifier,
    defaultSelection: DefaultCreditNoteSelection,
    namespace: null
  },
  {
    type: "findFirst",
    operationName: pluralModelApiIdentifier,
    modelApiIdentifier,
    defaultSelection: DefaultCreditNoteSelection,
    namespace: null
  },
  {
    type: "maybeFindFirst",
    operationName: pluralModelApiIdentifier,
    modelApiIdentifier,
    defaultSelection: DefaultCreditNoteSelection,
    namespace: null
  },
  {
    type: "findOne",
    operationName: pluralModelApiIdentifier,
    functionName: "findById",
    findByField: "id",
    findByVariableName: "id",
    modelApiIdentifier,
    defaultSelection: DefaultCreditNoteSelection,
    namespace: null
  },
  {
    type: "maybeFindOne",
    operationName: pluralModelApiIdentifier,
    functionName: "maybeFindById",
    findByField: "id",
    findByVariableName: "id",
    modelApiIdentifier,
    defaultSelection: DefaultCreditNoteSelection,
    namespace: null
  },
  {
    type: "findOne",
    operationName: pluralModelApiIdentifier,
    functionName: "findByCreditNoteNumber",
    findByField: "creditNoteNumber",
    findByVariableName: "creditNoteNumber",
    modelApiIdentifier,
    defaultSelection: DefaultCreditNoteSelection,
    namespace: null
  },
  {
    type: "maybeFindOne",
    operationName: pluralModelApiIdentifier,
    functionName: "maybeFindByCreditNoteNumber",
    findByField: "creditNoteNumber",
    findByVariableName: "creditNoteNumber",
    modelApiIdentifier,
    defaultSelection: DefaultCreditNoteSelection,
    namespace: null
  },
  {
    type: "action",
    operationName: "createCreditNote",
    operationReturnType: "CreateCreditNote",
    functionName: "create",
    namespace: null,
    modelApiIdentifier,
    operatesWithRecordIdentity: false,
    modelSelectionField: modelApiIdentifier,
    isBulk: false,
    isDeleter: false,
    variables: { creditNote: { required: false, type: "CreateCreditNoteInput" } },
    hasAmbiguousIdentifier: false,
    paramOnlyVariables: [],
    hasReturnType: false,
    acceptsModelInput: true,
    hasCreateOrUpdateEffect: true,
    defaultSelection: DefaultCreditNoteSelection
  },
  {
    type: "action",
    operationName: "bulkCreateCreditNotes",
    functionName: "bulkCreate",
    isBulk: true,
    isDeleter: false,
    hasReturnType: false,
    acceptsModelInput: true,
    operatesWithRecordIdentity: false,
    singleActionFunctionName: "create",
    modelApiIdentifier,
    modelSelectionField: pluralModelApiIdentifier,
    namespace: null,
    variables: {
      inputs: { required: true, type: "[BulkCreateCreditNotesInput!]" }
    },
    paramOnlyVariables: [],
    defaultSelection: DefaultCreditNoteSelection
  },
  {
    type: "action",
    operationName: "updateCreditNote",
    operationReturnType: "UpdateCreditNote",
    functionName: "update",
    namespace: null,
    modelApiIdentifier,
    operatesWithRecordIdentity: true,
    modelSelectionField: modelApiIdentifier,
    isBulk: false,
    isDeleter: false,
    variables: {
      id: { required: true, type: "GadgetID" },
      creditNote: { required: false, type: "UpdateCreditNoteInput" }
    },
    hasAmbiguousIdentifier: false,
    paramOnlyVariables: [],
    hasReturnType: false,
    acceptsModelInput: true,
    hasCreateOrUpdateEffect: true,
    defaultSelection: DefaultCreditNoteSelection
  },
  {
    type: "action",
    operationName: "bulkUpdateCreditNotes",
    functionName: "bulkUpdate",
    isBulk: true,
    isDeleter: false,
    hasReturnType: false,
    acceptsModelInput: true,
    operatesWithRecordIdentity: true,
    singleActionFunctionName: "update",
    modelApiIdentifier,
    modelSelectionField: pluralModelApiIdentifier,
    namespace: null,
    variables: {
      inputs: { required: true, type: "[BulkUpdateCreditNotesInput!]" }
    },
    paramOnlyVariables: [],
    defaultSelection: DefaultCreditNoteSelection
  },
  {
    type: "action",
    operationName: "deleteCreditNote",
    operationReturnType: "DeleteCreditNote",
    functionName: "delete",
    namespace: null,
    modelApiIdentifier,
    operatesWithRecordIdentity: true,
    modelSelectionField: modelApiIdentifier,
    isBulk: false,
    isDeleter: true,
    variables: { id: { required: true, type: "GadgetID" } },
    hasAmbiguousIdentifier: false,
    paramOnlyVariables: [],
    hasReturnType: false,
    acceptsModelInput: false,
    hasCreateOrUpdateEffect: false,
    defaultSelection: null
  },
  {
    type: "action",
    operationName: "bulkDeleteCreditNotes",
    functionName: "bulkDelete",
    isBulk: true,
    isDeleter: true,
    hasReturnType: false,
    acceptsModelInput: false,
    operatesWithRecordIdentity: true,
    singleActionFunctionName: "delete",
    modelApiIdentifier,
    modelSelectionField: pluralModelApiIdentifier,
    namespace: null,
    variables: { ids: { required: true, type: "[GadgetID!]" } },
    paramOnlyVariables: [],
    defaultSelection: null
  },
  {
    type: "action",
    operationName: "restoreCreditNote",
    operationReturnType: "RestoreCreditNote",
    functionName: "restore",
    namespace: null,
    modelApiIdentifier,
    operatesWithRecordIdentity: true,
    modelSelectionField: modelApiIdentifier,
    isBulk: false,
    isDeleter: false,
    variables: {
      id: { required: true, type: "GadgetID" },
      creditNote: { required: false, type: "RestoreCreditNoteInput" }
    },
    hasAmbiguousIdentifier: false,
    paramOnlyVariables: [],
    hasReturnType: false,
    acceptsModelInput: true,
    hasCreateOrUpdateEffect: true,
    defaultSelection: DefaultCreditNoteSelection
  },
  {
    type: "action",
    operationName: "bulkRestoreCreditNotes",
    functionName: "bulkRestore",
    isBulk: true,
    isDeleter: false,
    hasReturnType: false,
    acceptsModelInput: true,
    operatesWithRecordIdentity: true,
    singleActionFunctionName: "restore",
    modelApiIdentifier,
    modelSelectionField: pluralModelApiIdentifier,
    namespace: null,
    variables: {
      inputs: { required: true, type: "[BulkRestoreCreditNotesInput!]" }
    },
    paramOnlyVariables: [],
    defaultSelection: DefaultCreditNoteSelection
  },
  {
    type: "action",
    operationName: "sendCreditNote",
    operationReturnType: "SendCreditNote",
    functionName: "send",
    namespace: null,
    modelApiIdentifier,
    operatesWithRecordIdentity: true,
    modelSelectionField: modelApiIdentifier,
    isBulk: false,
    isDeleter: false,
    variables: {
      id: { required: true, type: "GadgetID" },
      creditNote: { required: false, type: "SendCreditNoteInput" }
    },
    hasAmbiguousIdentifier: false,
    paramOnlyVariables: [],
    hasReturnType: false,
    acceptsModelInput: true,
    hasCreateOrUpdateEffect: true,
    defaultSelection: DefaultCreditNoteSelection
  },
  {
    type: "action",
    operationName: "bulkSendCreditNotes",
    functionName: "bulkSend",
    isBulk: true,
    isDeleter: false,
    hasReturnType: false,
    acceptsModelInput: true,
    operatesWithRecordIdentity: true,
    singleActionFunctionName: "send",
    modelApiIdentifier,
    modelSelectionField: pluralModelApiIdentifier,
    namespace: null,
    variables: { inputs: { required: true, type: "[BulkSendCreditNotesInput!]" } },
    paramOnlyVariables: [],
    defaultSelection: DefaultCreditNoteSelection
  },
  {
    type: "action",
    operationName: "voidCreditNote",
    operationReturnType: "VoidCreditNote",
    functionName: "void",
    namespace: null,
    modelApiIdentifier,
    operatesWithRecordIdentity: true,
    modelSelectionField: modelApiIdentifier,
    isBulk: false,
    isDeleter: false,
    variables: {
      id: { required: true, type: "GadgetID" },
      creditNote: { required: false, type: "VoidCreditNoteInput" }
    },
    hasAmbiguousIdentifier: false,
    paramOnlyVariables: [],
    hasReturnType: false,
    acceptsModelInput: true,
    hasCreateOrUpdateEffect: true,
    defaultSelection: DefaultCreditNoteSelection
  },
  {
    type: "action",
    operationName: "bulkVoidCreditNotes",
    functionName: "bulkVoid",
    isBulk: true,
    isDeleter: false,
    hasReturnType: false,
    acceptsModelInput: true,
    operatesWithRecordIdentity: true,
    singleActionFunctionName: "void",
    modelApiIdentifier,
    modelSelectionField: pluralModelApiIdentifier,
    namespace: null,
    variables: { inputs: { required: true, type: "[BulkVoidCreditNotesInput!]" } },
    paramOnlyVariables: [],
    defaultSelection: DefaultCreditNoteSelection
  },
  {
    type: "action",
    operationName: "upsertCreditNote",
    operationReturnType: "UpsertCreditNote",
    functionName: "upsert",
    namespace: null,
    modelApiIdentifier,
    operatesWithRecordIdentity: false,
    modelSelectionField: modelApiIdentifier,
    isBulk: false,
    isDeleter: false,
    variables: {
      on: { required: false, type: "[String!]" },
      creditNote: { required: false, type: "UpsertCreditNoteInput" }
    },
    hasAmbiguousIdentifier: false,
    paramOnlyVariables: ["on"],
    hasReturnType: {
      "... on CreateCreditNoteResult": { hasReturnType: false },
      "... on UpdateCreditNoteResult": { hasReturnType: false }
    },
    acceptsModelInput: true,
    hasCreateOrUpdateEffect: true,
    defaultSelection: DefaultCreditNoteSelection
  },
  {
    type: "action",
    operationName: "bulkUpsertCreditNotes",
    functionName: "bulkUpsert",
    isBulk: true,
    isDeleter: false,
    hasReturnType: false,
    acceptsModelInput: true,
    operatesWithRecordIdentity: false,
    singleActionFunctionName: "upsert",
    modelApiIdentifier,
    modelSelectionField: pluralModelApiIdentifier,
    namespace: null,
    variables: {
      inputs: { required: true, type: "[BulkUpsertCreditNotesInput!]" }
    },
    paramOnlyVariables: ["on"],
    defaultSelection: DefaultCreditNoteSelection
  },
  {
    type: "computedView",
    operationName: "view",
    functionName: "view",
    gqlFieldName: "creditNoteGellyView",
    namespace: null,
    variables: {
      query: { type: "String", required: true },
      args: { type: "JSONObject" }
    }
  }
];
const CreditNoteManager = buildModelManager(
  modelApiIdentifier,
  pluralModelApiIdentifier,
  DefaultCreditNoteSelection,
  operations
);
export {
  CreditNoteManager,
  DefaultCreditNoteSelection
};
//# sourceMappingURL=CreditNote.js.map
